import { useEffect, useState } from "react";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _RequestNeed, _single } from "../../../core/services/dataBean/EntityCatalog";
import { SelectTypeNeed } from "../../erp/TypeNeed/SelectTypeNeed";
import { Alert } from "../../theme/Component/Alert";
import { SelectIDLnAssigned } from "../../theme/Component/SelectIDLnAssigned";
import { HistoryRequesNeed } from "./RequestNeedHistory/HistoryRequesNeed";

interface Props {
    interfaceProp?: "aplicant" | "manager"
}

export const RequestNeed = ({ interfaceProp = "aplicant" }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_RequestNeed);
    const [selectIDLn, setSelectIDLn] = useState<number>(null);
    const [selectIDLnName, setSelectIDLnName] = useState<string>("");
    const [visible, setVisible] = useState<boolean>(false);
    const [aprroveState, setApproveState] = useState<number>(NaN)

    useEffect(() => {
        let x = _single.getIDLnFunctional();
        if (x.length === 1) {
            setSelectIDLn(x[0].DataBeanProperties.IDLnFunctionalID)
            setSelectIDLnName(x[0].DataBeanProperties.FunctionalIDName)
        } else if (x.length > 1) {
            setVisible(true);
        }
        else {

        }
    }, [])

    useEffect(() => {
        if (selectIDLn) {
            getLista();
        }
    }, [selectIDLn])

    const [modalEdit, setModalEdit] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalHistory, setModalHistory] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const getLista = () => {
        const to = {
            IDLnTo: selectIDLn,
        }

        const from = {
            IDLnFrom: selectIDLn,
        }

        instance.getRequestNeedCatalogRender(interfaceProp === "aplicant" ? from : to, null, null).then(
            (resp) => {
                let x = resp;
                x.forEach(element => {
                    element.DataBeanProperties.EntityName = (element.DataBeanProperties.IDEmployee ?
                        `${element.DataBeanProperties.Name1} ${element.DataBeanProperties.Name2} ${element.DataBeanProperties.Surname1} ${element.DataBeanProperties.Surname2}`
                        :
                        "N/A"
                    )
                });
                setLista(x)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const createItem = () => {
        instance.createRequestNeed(bean.IDTypeNeed, bean.obs, _single.getAccountID()).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        )
    }

    const agregarItem = () => {
        setBean({})
        setModal({ ...modal, "view": true, "name": "Crear Nueva Necesidad" })
    }

    const updateItem = () => {
        instance.updateStateRequestNeed({
            "DataBeanProperties": bean,
            "DataBeanName": "com.orange.bean.RequestNeed"
        }, bean.obs, aprroveState, _single.getAccountID()).then(
            (ress) => {
                getLista()
                setApproveState(NaN)
                setModalC({ ...modalC, "view": false })
                setModalEdit({ ...modalEdit, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDRequestNeed', visible: true, mask: MASK_NUMBER },
        { title: 'Area Gestora', property: 'NameIDLnTo', visible: (interfaceProp === "aplicant" ? true : false) },
        { title: 'Solicitud', property: 'Description', visible: true },
        { title: 'Area Solicitante', property: 'NameIDLnFrom', visible: (interfaceProp === "aplicant" ? false : true) },
        { title: 'Solicitante', property: 'EntityName', visible: true },
        { title: 'Estado', property: 'State', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    //Cambios parciale 

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar Solicitud', icono: 'ri-edit-2-line', visible: (_single.canEdit() && bean.State == 11), evento: () => { setModalEdit({ ...modalEdit, "view": true, "name": "Editar Necesidad" }); setApproveState(11) } },
            { titulo: 'Aprobar Solicitud', icono: 'ri-checkbox-circle-fill', visible: (interfaceProp === "manager" && bean.State == 11), evento: () => { setModalC({ ...modalC, "view": true, "name": "Confirmar Aprobación" }); setApproveState(12) } },
            { titulo: 'Declinar Solicitud', icono: 'ri-indeterminate-circle-fill', visible: (interfaceProp === "manager" && bean.State == 11), evento: () => { setModalC({ ...modalC, "view": true, "name": "Confirmar Rechazo" }); setApproveState(13) } },
            { titulo: 'Ver Historial de Solicitud', icono: 'ri-history-line', visible: true, evento: () => { setModalHistory({ ...modalHistory, "view": true, "name": `Historial de la Necesidad ${bean.IDRequestNeed}` }); } },
        ]

        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: (_single.canCreate() && interfaceProp == "aplicant"), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    const setRowBean = (obj) => {
        setBean(obj);
        setApproveState(NaN)
    }

    return (
        <BasicPage titulo={`Bandeja de ${interfaceProp === "aplicant" ? "Solucitudes" : "Gestion"} de Necesidades de Compras ${selectIDLnName ?? ""} `}>
            <div className="row">
                {visible &&
                    <div className="col-md-6">
                        <SelectIDLnAssigned returnType="Object" idSelector={selectIDLn} onChange={(e) => { setSelectIDLn(e?.IDLnFunctionalID); setSelectIDLnName(e?.FunctionalIDName) }} />
                    </div>
                }

                {selectIDLn ?
                    <div className="col-md-12">
                        <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} head={head} body={lista} rowSet={setRowBean} />
                    </div>
                    :
                    <div className="col-md-12">
                        <Alert children={"Debe Seleccionar un Area"} clase="warning" />
                    </div>
                }

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={() => { createItem() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <SelectTypeNeed idSelector={bean.IDTypeNeed} onChange={(e) => { setBean({ ...bean, "IDTypeNeed": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Necesidad</label>
                                <textarea className="form-control" value={bean.obs} onChange={(e) => { setBean({ ...bean, "obs": e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalEdit} updateModal={setModalEdit} eventModal={() => { updateItem() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <SelectTypeNeed idSelector={bean.IDTypeNeed} onChange={(e) => { setBean({ ...bean, "IDTypeNeed": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Necesidad</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observación</label>
                                <textarea className="form-control" value={bean.obs} onChange={(e) => { setBean({ ...bean, "obs": e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalC} updateModal={setModalC} eventModal={() => { updateItem() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observación</label>
                                <textarea className="form-control" value={bean.obs} onChange={(e) => { setBean({ ...bean, "obs": e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalHistory} updateModal={setModalHistory} >
                        <HistoryRequesNeed _idRequest={bean.IDRequestNeed} />
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}